/** Banner görseli (jpeg/png/gif) için üst sınır; değişmedi. */
export const BANNER_IMAGE_MAX_BYTES = 30000000

/** Banner videosu (mp4) için üst sınır: 200 MB. */
export const BANNER_VIDEO_MAX_BYTES = 200 * 1024 * 1024

const isVideo = (type?: string) => (type || '').toLowerCase() === 'video/mp4'

/** mp4 banner videosu mu? Video base64'e okunmaz, multipart ile yüklenir (`UploadBannerVideoApi`). */
export const isBannerVideo = (file?: { type?: string } | null): boolean => isVideo(file?.type)

/**
 * Dosya sınırı aşıyorsa kullanıcıya gösterilecek hata metni, aşmıyorsa null.
 * Dosya base64'e okunmadan ÖNCE çağrılır: sınırı aşan büyük bir video belleğe hiç alınmaz.
 */
export function bannerUploadSizeError(file: { size: number; type?: string }): string | null {
  if (isVideo(file.type)) {
    return file.size > BANNER_VIDEO_MAX_BYTES ? "Video 200 MB'den küçük olmalıdır!" : null
  }
  return file.size > BANNER_IMAGE_MAX_BYTES ? 'Resim 30mb den küçük olmalıdır!' : null
}
